import { isBlockedCapabilityRoute } from '@/config/platform-capabilities';

/**
 * Presentation boundary for capabilities which are not certified for new
 * merchant activity. The platform capability registry owns route exposure;
 * backend service gates remain authoritative for mutations, events and jobs.
 */
export function isLaunchBlockedRoute(pathname: string): boolean {
  return isBlockedCapabilityRoute(pathname);
}
